import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'redux/slices/authSlice';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { createFormAction } from 'redux/slices/formSlice';
import Form from './FormForm';
import UserRole from '../../../common/enums/roles';

const FormCreate = ({ role, form = {}, onSubmit, onCancel }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const user = useSelector(getUser);

    const initValue = useMemo(
        () => ({
            fields: [],
            ...form,
            organizationId: role !== UserRole.ROOT ? user?.organizationId : null,
        }),
        [user?.organizationId, role, form],
    );

    const handleSubmit = ({ data, onSuccess, onFailure }) => {
        dispatch(
            createFormAction({
                data: data,
                onSuccess: (response) => {
                    if (onSubmit) {
                        try {
                            onSubmit(response);
                        } catch (e) {
                            console.error(`Error executing form create submit callback: ${e.message}`);
                        }
                    }
                    onSuccess(response);
                    dispatch(closeCustomDialogAction());
                },
                onFailure: onFailure,
            }),
        );
    };

    const handleClose = () => {
        if (onCancel) {
            try {
                onCancel();
            } catch (e) {
                console.error(`Error executing form create cancel callback: ${e.message}`);
            }
        }
        dispatch(closeCustomDialogAction());
    }

    return (
        <Form
            action={t('form.formCreate.new')}
            form={initValue}
            onSubmit={handleSubmit}
            close={handleClose}
        />
    );
};

export default FormCreate;
